import { RefObject } from 'react';
import Link, { LinkProps } from 'next/link';
import { linkStyles } from './link.css';

export type LinkNextProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
  LinkProps &
  React.RefAttributes<HTMLAnchorElement>;

export const LinkNext = ({
  className = '',
  ref,
  ...props
}: LinkNextProps & { ref?: RefObject<HTMLAnchorElement> }) => {
  return <Link ref={ref} className={`${linkStyles} ${className}`} {...props} />;
};
